<template>
    <v-expansion-panel>
        <v-expansion-panel-header hide-actions>
            <template v-slot:default="{ open }">
                <div
                    class="subtitle-1"
                    :class="hasError ? 'error--text' : ''"
                >
                    {{ parsedTitle }}
                </div>
                <v-spacer />
                <div class="d-flex justify-end mr-2">
                    <slot name="actions" />
                </div>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <span class="flex-grow-0">
                            <icon-button
                                :on="on"
                                :icon="open ? 'ChevronUp' : 'ChevronDown'"
                            />
                        </span>
                    </template>
                    {{ open ? $t('Collapse') : $t('Expand') }}
                </v-tooltip>
            </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
            <slot />
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>
import { $t } from "@/i18n";
import {computed, ref} from "@vue/composition-api";

export default {
    name: "ExpansionPanel",
    props: {
        item: {
            type: Object,
            required: true
        },
        title: {
            type: Function,
            default: null
        },
        hasError: {
            type: Boolean,
            default: false
        }
    },
    setup(props) {
        const parsedTitle = computed(() => {
            if (typeof props.title === 'function') {
                return props.title(props.item)
            } else {
                return props.item.title
            }
        })

        return {
            parsedTitle
        };
    }
};
</script>

<style scoped lang="scss">
.v-expansion-panel {
    margin-bottom: 8px;
    border-radius: 8px;

    .v-expansion-panel-header {
        padding-top: 8px;
        padding-bottom: 8px;
        min-height: 52px;
        overflow: auto;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;

        &.v-expansion-panel-header--active {
            border-bottom-left-radius: 0 !important;
            border-bottom-right-radius: 0 !important;
        }
    }

    &:after {
        display: none;
    }

    &:before {
        box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.02), 0px 1px 12px rgba(0, 0, 0, 0.12);
    }
}
</style>